export default "__VITE_ASSET__qDk68b5r__"